/**
 * Egypt's tag. `Intl` resolves a BARE `ar` to the `latn` numbering system, so
 * `(5).toLocaleString("ar")` returns "5", not "٥". `ar-EG` resolves to `arab`.
 */
const ARABIC_LOCALE = "ar-EG";

/**
 * Turn a portal locale ("ar" | "en") into the tag `Intl` should actually be
 * given.
 *
 * Every number and date the portal renders has to go through this. Passing the
 * bare locale is the reason an Arabic seller saw "5 طلبات" directly beneath
 * "٩٩٠ ج.م", and "5.0 من ٥" carrying both numeral systems inside one string:
 * money went through `formatCurrency` (which pins ar-EG) while the counts and
 * dates beside it did not.
 *
 * Several call sites already wrote `locale === "ar" ? "ar-EG" : "en-US"` inline.
 * That is this function, copied — which is exactly how the ones that forgot it
 * drifted. Prefer this helper so there is one place to be right.
 */
export function intlLocale(locale: string): string {
  return locale === "ar" ? ARABIC_LOCALE : locale;
}
